import React from 'react';
import {Button} from 'react-bootstrap';


export const CompleteBolPage = (props) => {

    return (
        <div className='container'>
            <div className="card-container-form">
                <div className="col-md-offset-3">
                    <div className="section-title">Business Online Profile Confirmation</div>
                    <div className="input-group greyText fontSize">
                        <p>Thank you, you have completed capturing for your new business online profile.</p>
                        <p>You will receive a notification once the profile has been approved/validated.</p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default CompleteBolPage;
